<div #root>
  <div class="autocomplete-handler">
    <ng-content></ng-content>
  </div>
</div>
